import { ApolloClient, InMemoryCache, gql } from "@apollo/client";
import axios from "axios";
import StorageService from "../../util/storage";

const client = new ApolloClient({
    uri: `${process.env.REACT_APP_BACKEND_URL}/graphql`,
    cache: new InMemoryCache(),
    headers: {
        Authorization: `${StorageService.getItem("bearer")}`,
    }
});

export const fetchOrganisationContent = async (id) => {
    const query = gql`
        query OrganisationContent($id: String!) {
            contents(filters: { organisation: { orgId: { eq: $id } } }) {
                data {
                    id
                    attributes {
                        logo {
                            data {
                                attributes {
                                    url
                                }
                            }
                        }
                        heroTitle
                        heroImage {
                            data {
                                attributes {
                                    url
                                }
                            }
                        }
                        heroDescription
                        showAlert
                        alertText
                    }
                }
            }
        }
    `;
    const { data } = await client.query({
        query,
        variables: { id },
    });
    return data.contents.data.length > 0 ? data.contents.data[0] : null;
};

export const getMemberNetworks = async (id) => {
    const query = gql`
        query MemberNetworks($id: String!) {
            memberNetworks(filters: { organisation: { orgId: { eq: $id } } }, pagination: { limit: 1000 }) {
                data {
                    id
                    attributes {
                        name
                    }
                }
            }
        }
    `;
    const { data } = await client.query({
        query,
        variables: { id },
    });
    return data.memberNetworks.data;
}

export const getOrganisation = async () => {
    const hostname = window.location.host;
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/organisations?filters[hostnames][url][$eq]=${hostname}&filters[hostnames][type][$eq]=LMS&populate=hostnames,LMS,LMS.required_links,allowOtherTenants,Regions`
    );
    if (response.data.data.length === 0) {
        return null;
    }
    return response.data.data[0];
};